<script setup lang="ts">
import { computed } from 'vue'
import Button from './Button.vue'

interface Props {
  show: boolean
  timeRemaining: number
}

const props = defineProps<Props>()

const emit = defineEmits<{
  extend: []
  logout: []
}>()

const formattedTime = computed(() => {
  const minutes = Math.floor(props.timeRemaining / 60000)
  const seconds = Math.floor((props.timeRemaining % 60000) / 1000)
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
})
</script>

<template>
  <Teleport to="body">
    <Transition name="fade">
      <div
        v-if="show"
        class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      >
        <div class="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 text-center">
          <!-- Warning Icon -->
          <div class="w-16 h-16 bg-vfr-yellow/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <span class="text-3xl">⏱️</span>
          </div>

          <!-- Title -->
          <h2 class="text-xl font-bold text-vfr-dark mb-2">
            Session expire bientôt
          </h2>

          <!-- Message -->
          <p class="text-gray-600 mb-4">
            Votre session expire dans
            <span class="font-bold text-vfr-red">{{ formattedTime }}</span>
          </p>

          <!-- Actions -->
          <div class="flex flex-col gap-3">
            <Button
              variant="primary"
              class="w-full"
              @click="emit('extend')"
            >
              Rester connecté
            </Button>
            <Button
              variant="outline"
              class="w-full"
              @click="emit('logout')"
            >
              Se déconnecter
            </Button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
